<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" />
      <img :src="banner_m" v-else />
      <div class="banner_title">{{ banner_title }}</div>
    </div>
    <div class="module">
      <div class="wrap">
        <Question :list="list" @handleSubmit="handleSubmit"></Question>
      </div>
    </div>
    <Rdialog
      :isRegister="isRegister"
      :isEmail="isEmail"
      :isExamination="isExamination"
      :ptext="ptext"
    ></Rdialog>
  </div>
</template>

<script>
import Rdialog from "@/components/rdialog/index.vue";
import Question from "@/components/question/index.vue";
import { SubmitExamination, UserInfo, GetUserLogs } from "../../api/index.js";
import surveylist from "@/assets/json/survey.json"
import { ApiToken } from '@/utils/ApiToken'

export default {
  data() {
    return {
      isRegister: false,
      isEmail: false,
      isExamination: false,
      ptext: "",
      banner_title: "有奖调研",
      banner: "https://staticdn.ht-s.cn/se/ciif/2023/exhibition/banner.png",
      banner_m: "https://staticdn.ht-s.cn/se/ciif/2023/exhibition/banner_m.png",
      list: surveylist,
    };
  },
  components: {
    Rdialog,
    Question
  },
  mounted() {
    GetUserLogs({
      visitName: '页面访问-有奖调研',
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 7756
    })
    if (Date.now() >= new Date(ApiToken.surveyTime.replace(/-/g, "/")).getTime()) {
      setTimeout(() => {
        if (this.$store.state.islogin && this.$store.state.userInfo.IsExamination == 1) {
          this.isExamination = true;
          this.ptext = "感谢您的参与，您已完成有奖调研，奖励积分已发放至您的个人账户。";
          this.isRegister = false;
          this.isEmail = false;
        }
      }, 500);
    }else{
      this.isExamination = true;
      this.ptext = "施耐德电气2023年工博会<br>有奖调研尚未开启<br>敬请期待!";
      this.isRegister = false;
      this.isEmail = false;
    }
  },
  methods: {
    handleSubmit(answerData){
      this.SubmitExamination(answerData, this.$route.query.track);
    },
    SubmitExamination(data, track) {
      SubmitExamination(data, track).then((res) => {
        if (res.Status == 1) {
          // window.location.reload();
          UserInfo(track).then((res) => {
            if (res.Status == 1) {
              this.$store.dispatch("userInfo", res.Data);
              this.isExamination = true;
              this.ptext = "感谢您参加有奖调研，获得<br>500积分。";
              this.isRegister = false;
              this.isEmail = false;
            }
          });
        }
      });
    },
  },
  watch: {},
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style>
</style>